import React, { useEffect,useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import FormInput from '../../Common/formInput';
import { Grid, Button, Box, InputLabel, Snackbar, Tooltip } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getUserDetailsData, updatePaymentDetails, getUserChatgptCredits, addChatgptCredits } from '../../../actions/get-user-details';
import { currentUserSelector } from '../../../selectors/currentUserSelector'
import Alert from '@material-ui/lab/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';
import currentPackageSelector from '../../../selectors/packageInfo';

const useStyles = makeStyles({
    inputLabel: {
        color: '#08090a',
        fontSize: '0.875rem',
        fontWeight: '400',
        paddingBottom: '0.625rem',
        //display: 'inline-flex !important',
    },
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '8px 14px'
        },
    }
})


const AiCreditsForm = () => {
    const { t } = useTranslation();
    const userCardData = useSelector(state => state.fetchUserDetails.data);
    const dispatch = useDispatch();
    const [snackBarMessage, setSnackBarMessage] = useState('');
    const [increaseCreditsClicked, setIncreaseCreditsClicked] = useState(false)
    const [totalAmount, setTotalAmount] = useState(10)
    const [totalCredits, setTotalCredits] = useState(100000)
    const credits = userCardData && userCardData[0]?.attributes?.credits
    const packageInfo = useSelector(currentPackageSelector);

     console.log("card details fetched from api",userCardData && userCardData[0]?.attributes?.credits)

    useEffect(() => {
        dispatch(getUserChatgptCredits())
    }, [])

    const conversionRate = 100000/10;

    const handleAmountChange = (amount) => {
        setTotalAmount(amount)
        setTotalCredits(amount * conversionRate)

    }  

    const handleCreditsChange = (credits) => {
        setTotalCredits(credits)
        setTotalAmount(credits/conversionRate)

    }

    const handleAddChatgptCredits = () => {
        dispatch(addChatgptCredits({credits:parseInt(totalCredits), amount: parseInt(totalAmount)})).then((response)=> {
            if(response){
                setIncreaseCreditsClicked(false)
                dispatch(getUserChatgptCredits())
            }
        })
    }

    const handleCreditsStep = (step) => {
        setTotalCredits(totalCredits + step)
        setTotalAmount((totalCredits+step)/ conversionRate)
    }

    const handlCloseSnackBar = () => {
        setTimeout(() => setSnackBarMessage(''), 6000);
    }

    const handlClose = () => {
        setSnackBarMessage('');
    }

    return (
        <Grid container>
                        {/* {stripePromise ? (
                             <Grid item xs={12} md={6}>
                                <Elements stripe={loadStripe(publicKey)}>
                                  <CheckoutForm onPaymentMethodId={handlePaymentMethodId} />
                                </Elements>
                             </Grid>
                          ) : (
                              <Grid item xs={12} md={6}>
                                  <CircularProgress size={60} />
                              </Grid>
                          )} */}
                        {/* {!credits? 
                            <Grid item xs={12} >
                                <Box display='flex' justifyContent='center' alignItems='center' padding='1rem'>
                                    <CircularProgress size={30} />
                                </Box>
                            </Grid>
                         : */}
                         <>
                          <Grid item xs={12}>
                    <FormInput
                        id='availableCredits'
                        label='Available Credits'
                        placeholder=""
                        name="availableCredits"
                        disabled={true}
                        value={credits}
                        // onChange={(e) => handleCardNumber(e.target.value)}
                        inputProps={{
                            maxLength: 16,
                            minLength: 16,
                            inputMode: 'numeric'
                        }}
                    />
                </Grid>
            {!increaseCreditsClicked?
            <Grid item xs={12}>
                <Box pt={2} display="flex" flexDirection="row-reverse" justifyContent="">
                <Tooltip title={packageInfo?.isTrial ? "Please subscribe to add more credits" : "" } disableHoverListener={!packageInfo?.isTrial}>
                <span>
                    <Button disableRipple disabled={packageInfo?.isTrial} variant="contained" color="primary" style={{ marginLeft: '0.5rem' }} autoFocus onClick={() => setIncreaseCreditsClicked(true)}>
                            Increase Credits
                    </Button>
                </span>
                </Tooltip>
                </Box>
            </Grid>
            :
            <Grid item xs={12}>
                <Box pt={2}>
                    <FormInput
                        id='totalAmount'
                        label='Total Amount ($)'
                        placeholder=""
                        name="totalAmount"
                        value={totalAmount}
                        onChange={(e) => handleAmountChange(e.target.value)}
                        inputProps={{
                            maxLength: 16,
                            minLength: 16,
                            inputMode: 'numeric'
                        }}
                    />
                     <FormInput
                        id='totalCredits'
                        label='Total Credits'
                        placeholder=""
                        name="totalCredits"
                        value={totalCredits}
                        onChange={(e) => handleCreditsChange(e.target.value)}
                        step={1000}
                        onKeyDown={(e) => {
                            if(e.key === 'ArrowUp') handleCreditsStep(1000)
                            if(e.key === 'ArrowDown') handleCreditsStep(-1000)
                        }}
                        inputProps={{
                            maxLength: 16,
                            minLength: 16,
                            inputMode: 'numeric'
                        }}
                    />
                    <span style={{display:'flex', justifyContent:'space-between'}}>
                        <Box pt={2} display="flex" flexDirection="row" justifyContent="">
                            <Button disableRipple variant="contained" color="primary" style={{ marginLeft: '0.5rem' }} autoFocus onClick={() => setIncreaseCreditsClicked(false)}>
                                Cancel
                            </Button>
                        </Box>
                        <Box pt={2} display="flex" flexDirection="row-reverse" justifyContent="">
                            <Button disableRipple variant="contained" color="primary" style={{ marginLeft: '0.5rem' }} autoFocus onClick={() => handleAddChatgptCredits()}>
                                Buy
                            </Button>
                        </Box>
                    </span>
                </Box>
            </Grid>
        }
            

                        </>
                         {/* } */}
               
            {!!snackBarMessage && (
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right'
                        }}
                        autoHideDuration={1000}
                        open={!!snackBarMessage}
                        onClose={handlCloseSnackBar}>
                        <Alert
                            elevation={6}
                            variant="filled"
                            onClose={handlClose}
                            severity="info">
                            {snackBarMessage}
                        </Alert>
                    </Snackbar>
                )}
        </Grid >
    );
};

export default AiCreditsForm;
